import { Flex, Text, Box } from '@chakra-ui/react';

interface SignUpStepperProps {
  activeStep: number;
  activeFilled?: boolean;
}

export function SignUpStepper({ activeStep, activeFilled = true }: SignUpStepperProps) {
  const steps = [
    { label: 'Join Catch', icon: '1' },
    { label: 'Learn Your Risk', icon: '2' },
    { label: 'Take Action', icon: '3' },
  ];

  return (
    <Flex justify="space-between" align="center" w="full">
      {steps.map((step, index) => (
        <Flex key={step.label} direction="column" align="center" position="relative" w={{ base: '120px', md: 'auto' }}>
          <Flex
            align="center"
            justify="center"
            w={{ base: '42px', md: '58px' }}
            h={{ base: '42px', md: '58px' }}
            borderRadius="full"
            bg={
              activeStep === index
                ? activeFilled
                  ? 'linear-gradient(to bottom, #204660, #0E1D27)'
                  : 'transparent'
                : 'transparent'
            }
            borderWidth={activeStep === index ? { base: '2px', md: '2.75px' } : { base: '2px', md: '3px' }}
            borderColor={activeStep === index ? '#0E1D27' : '#D1D5DB'}
          >
            <Text
              fontSize={{ base: '24px', md: '33px' }}
              fontWeight="400"
              color={activeStep === index ? (activeFilled ? '#FFFFFF' : '#0E1D27') : '#D1D5DB'}
            >
              {step.icon}
            </Text>
          </Flex>
          <Text
            mt={{ base: '6px', md: '8px' }}
            fontSize={{ base: '14px', md: '22px' }}
            fontWeight={{ base: '400', md: '600' }}
            color="#183344"
            textAlign="center"
          >
            {step.label}
          </Text>
          {index < steps.length - 1 && (
            <Box
              position="absolute"
              top={{ base: '20px', md: '28px' }} // Adjusted for smaller circle size
              left={{ base: 'calc(50% + 28px)', md: 'calc(50% + 38px)' }} // Adjust this value to position the line correctly
              w={{ base: 'calc(100% - 10px)', md: 'calc(100% - 20px)' }} // Adjust this value for line length between steps
              maxW={{ base: '70px', md: '135px' }} // Max width based on Figma for mobile and desktop
              h={{ base: '2px', md: '4px' }}
              bg={
                activeStep + 1 > index
                  ? 'linear-gradient(90deg, #204660 -1.45%, rgba(14, 29, 39, 0.00) 101.45%)'
                  : '#F0F5F6'
              }
            />
          )}
        </Flex>
      ))}
    </Flex>
  );
}
